import { Sparkles, BadgeCheck, Clock } from "lucide-react";
import { cn } from "@/lib/utils";

// Launch scarcity offer for the waitlist: the first 5,000 members lock in lifetime 50% off BLOQ+
// plus an exclusive, un-earnable Founding badge. (Entitlement honored by the backend at launch —
// see /app/HANDOFF_monetization.md.)
export function FoundingOffer({ className = "", compact = false }) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-2xl border border-bloq-mint/30 bg-gradient-to-br from-bloq-mint/[0.08] to-bloq-purple/[0.06] p-4 text-left",
        className,
      )}
      data-testid="founding-offer"
    >
      <div className="pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full bg-bloq-mint/10 blur-2xl" aria-hidden />
      <div className="flex flex-wrap items-center gap-2">
        <span className="inline-flex items-center gap-1 rounded-full bloq-gradient px-2.5 py-0.5 text-[10px] font-black uppercase tracking-wider text-bloq-bg">
          <Sparkles className="h-3 w-3" /> Founding Member
        </span>
        <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-bloq-mint">
          <Clock className="h-3 w-3" /> First 5,000 only
        </span>
      </div>
      <p className="mt-2 text-sm font-semibold text-white">
        Lock in <span className="bloq-gradient-text">50% off BLOQ+ — for life</span>
      </p>
      {!compact && (
        <p className="mt-1 flex items-start gap-1.5 text-xs text-bloq-muted">
          <BadgeCheck className="mt-0.5 h-3.5 w-3.5 shrink-0 text-bloq-mint" />
          Plus an exclusive Founding badge that can never be earned again. Join now to claim your spot.
        </p>
      )}
    </div>
  );
}
